import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { SettingsSiteControllerBase } from "../../_shared/base";

import type { SiteControllerSettingBaseFormModel } from "../../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../../model/base/use-case/use-create-model/methods";

type Props = {
	hotelID: string;
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;
};

export const SettingsSiteControllerNotUsingMain = ({
	hotelID,
	viewModel,
	siteControllerSettingBaseFormModelMethodsType, //
}: Props) => {
	return (
		<FeatureIslandMainWithBackGround>
			<SettingsSiteControllerBase
				hotelID={hotelID}
				siteControllerType={viewModel.siteControllerType}
				siteControllerSettingBaseFormModelMethods={siteControllerSettingBaseFormModelMethodsType}
			/>
		</FeatureIslandMainWithBackGround>
	);
};

SettingsSiteControllerNotUsingMain.displayName = "SettingsSiteControllerNotUsingMain";
